import { jsx } from "react/jsx-runtime";
import { COMPONENT_MAP } from "./constants.js";
function SystemDefinedLinkUI({
  dataTestId = "",
  entry,
  linkStyle,
  moduleSettings,
  locale
}) {
  if (!(entry == null ? void 0 : entry.link_type)) {
    console.error("SystemDefinedLink error: Invalid entry.");
    return null;
  }
  const Component = COMPONENT_MAP[entry == null ? void 0 : entry.link_type];
  if (!Component) {
    throw new Error(
      `SystemDefinedLink component mapping missing for linkType: ${entry == null ? void 0 : entry.link_type}`
    );
  }
  return /* @__PURE__ */ jsx(
    Component,
    {
      dataTestId,
      entry,
      linkStyle,
      locale,
      moduleSettings
    }
  );
}
export {
  SystemDefinedLinkUI
};
